import { useSelector } from 'react-redux';
import * as React from 'react';
import { selectProjectsList } from '../../selectors/projects';
import { ProjectsList } from '../../components/ProjectsList';
import { ProjectCardContainer } from '../ProjectCardContainer';
import { EmptyPageContainer } from '../EmptyPageContainer';
import { MortgageBanner } from '../../components/MortgageBanner';
import { useBannerRenderer } from './hooks/useBannerRenderer';
import { OpenVillageBannerContainer } from '../OpenVillageBannerContainer';
import { useDeviceType } from '@cian/ui-kit';

export const ProjectsListContainer = () => {
  const deviceType = useDeviceType();
  const projects = useSelector(selectProjectsList);
  const projectsCount = projects.length;
  const renderOpenVillageBanner = useBannerRenderer({
    component: <OpenVillageBannerContainer />,
    position: deviceType === 'desktop' ? 1 : 2,
    totalSize: projectsCount,
  });
  const renderMortgageBanner = useBannerRenderer({
    component: <MortgageBanner />,
    position: 5,
    totalSize: projectsCount,
  });

  if (!projectsCount) {
    return <EmptyPageContainer />;
  }

  return (
    <>
      <ProjectsList>
        {projects.map((project, index) => {
          return (
            <React.Fragment key={project.id}>
              {renderOpenVillageBanner(index)}
              {renderMortgageBanner(index)}
              <ProjectCardContainer key={project.id} index={index} {...project} />
            </React.Fragment>
          );
        })}
      </ProjectsList>
      {renderOpenVillageBanner()}
      {renderMortgageBanner()}
    </>
  );
};
